"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
    DateFormat["DD_MM_YYYY_DASH"] = "DD-MM-YYYY";
    DateFormat["DD_MM_YYYY_SLASH"] = "DD/MM/YYYY";
})(DateFormat || (exports.DateFormat = DateFormat = {}));
//# sourceMappingURL=DateEnums.js.map